// extracted by mini-css-extract-plugin
module.exports =  {"card":"IuhRyFgQlP9vw7xMsTnS","collapseButton":"f0amZkadI1ck5o8kiwt9"};